import React from "react";

import { cx } from "~/tools/class-variance";
import { format } from "~/tools/date-time";
import type { Time } from "~/tools/date-time/time";

export const MessageTimestamp: React.FC<{ createdAt: Time; className?: string }> = ({ createdAt, className }) => (
	<span className={cx("mt-1 block text-11 text-grey-700", className)}>{format(createdAt, "HH:mm")}</span>
);
